import React, { FC, useEffect, useState } from 'react'
import { GDPRSettings, GDPRConfigBuilder, cookiesTool } from 'react-gdpr'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { actions } from '../../redux'
import { selectors } from '../../redux/app/redux'

import * as SC from './styled'

export type GDPRBannerProps = {
  className?: string
}

const GDPRSettingsPanel: FC<GDPRBannerProps> = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const cookiesSettings = useSelector(selectors.cookiesSettings)

  const [allowRender, setAllowRender] = useState(false)
  const [renderCounter, setRenderCounter] = useState(0)

  function incRender() {
    setRenderCounter(renderCounter + 1)
  }

  function handleToggle(id: any, value: any) {
    cookiesTool.setActive(id, value)
    incRender()
  }

  function handleValidate() {
    cookiesTool.setActive('cookiesEdited', true)

    if (cookiesTool.isActive('analytics')) {
      dispatch(actions.tracking.enableTracking())
    }

    dispatch(actions.app.closeCookiesSettings())
  }

  useEffect(() => {
    setAllowRender(true)
  }, [])

  if (!allowRender || !cookiesSettings) {
    return null
  }

  const configBuilder = new GDPRConfigBuilder()

  configBuilder
    .setLocale(
      t('gdpr.settings.title'),
      t('gdpr.settings.decription'),
      t('gdpr.settings.button.accept.label'),
      t('gdpr.settings.toggle.active.label'),
      t('gdpr.settings.toggle.inactive.label'),
      t('gdpr.settings.always.active')
    )
    .addSetting(
      'analytics',
      t('gdpr.settings.analytics.title'),
      t('gdpr.settings.analytics.description'),
      cookiesTool.isActive('analytics'),
      true
    )

  const config = configBuilder.getConfig()

  return (
    <SC.Container>
      <GDPRSettings onValidate={handleValidate} onToggle={handleToggle} {...config} />
    </SC.Container>
  )
}

export default GDPRSettingsPanel
